export const SET_IS_PENDING = 'rpb2b-react/addresses/SET_IS_PENDING';
export type SET_IS_PENDING = typeof SET_IS_PENDING;

export const SET_ERROR = 'rpb2b-react/addresses/SET_ERROR';
export type SET_ERROR = typeof SET_ERROR;

export const SET_ADDRESSES = 'rpb2b-react/addresses/SET_ADDRESSES';
export type SET_ADDRESSES = typeof SET_ADDRESSES;

export default {
  SET_IS_PENDING,
  SET_ERROR,
  SET_ADDRESSES
};
